module.exports = __webpack_public_path__ + "img/cookies-clip-art-17.5d206ca8.png";